class TextAndImageCarousel extends HTMLElement {
  constructor() {
    super();

    const _this = this;

    console.log("this", this);

    // make indicator buttons

    // text slides

    this.textSlides = this.querySelectorAll(
      ".image-and-text-carousel__text-slide"
    );

    this.imageSlides = this.querySelectorAll(
      ".image-and-text-carousel__image-slide"
    );

    this.textSlides.forEach((slide, index) => {
      const indicator = document.createElement("button");
      indicator.classList.add("image-and-text-carousel__indicator");
      indicator.setAttribute("data-slide", index);
      indicator.setAttribute("aria-label", `Go to slide ${index + 1}`);
      indicator.innerText = index + 1;
      indicator.classList.add("indicator");

      if (index === 0) {
        indicator.classList.add("active");
      }

      indicator.addEventListener("click", () => {
        this.currentSlide = index;
        this.update();
      });
      this.querySelector(".image-and-text-carousel__indicators").appendChild(
        indicator
      );

      const altIndicator = indicator.cloneNode(true);

      altIndicator.addEventListener("click", () => {
        this.currentSlide = index;
        this.update();
      });

      this.querySelector(
        ".image-and-text-carousel__indicators-portrait"
      ).appendChild(altIndicator);

      // heartbeat

      const beat = setInterval(() => {
        this.checkHeight();
      }, 500);
    });

    this.indicators = this.querySelectorAll(
      ".image-and-text-carousel__indicator"
    );

    this.indicatorsAlt = this.querySelectorAll(
      ".image-and-text-carousel__indicators-portrait .indicator"
    );

    console.log("this.textSlides", this.textSlides, this.currenSlide);

    this.currentSlide = 0;

    this.previousCurrentSlide = -1;

    this.previousSlide = this.previousSlide.bind(this);

    this.previousButton = this.querySelector(".previous-button");
    this.previousButton.addEventListener("click", this.previousSlide);

    this.nextSlide = this.nextSlide.bind(this);

    this.nextButton = this.querySelector(".next-button");

    this.nextButton.addEventListener("click", this.nextSlide);

    this.checkHeight = this.checkHeight.bind(this);
    this.checkHeight();

    // make next and previous buttons
    window.addEventListener("resize", () => {
      this.checkHeight();
    });

    this.update();
  }

  nextSlide() {
    this.currentSlide = this.currentSlide + 1;

    this.update();
  }

  previousSlide() {
    this.currentSlide--;

    this.update();
  }

  checkHeight() {
    this.slideHeight = this.textSlides[this.currentSlide].offsetHeight;

    /// get the tallest slide
    this.textSlides.forEach((slide) => {
      if (slide.offsetHeight > this.slideHeight) {
        this.slideHeight = slide.offsetHeight;
      }
    });

    this.querySelector(
      ".image-and-text-carousel__text-slides__wrapper"
    ).style.minHeight = `${this.slideHeight}px`;
  }

  update() {
    console.log(
      "this.currentSlide",
      this.currentSlide,
      this.previousCurrentSlide,
      this.currentSlide,
      this.previousCurrentSlide < this.currentSlide
    );

    if (this.previousCurrentSlide < this.currentSlide) {
      this.classList.add("direction-forward");
    } else {
      this.classList.remove("direction-forward");
    }

    this.previousCurrentSlide = this.currentSlide;

    this.textSlides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        slide.classList.add("active");
      } else {
        slide.classList.remove("active");
      }
    });

    this.imageSlides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        slide.classList.add("active");
        slide.classList.remove("next");
      } else if (index === this.currentSlide + 1) {
        slide.classList.add("next");
        slide.classList.remove("active");
      } else {
        slide.classList.remove("active");
        slide.classList.remove("next");
      }

      if (index < this.currentSlide) {
        slide.classList.add("before");
      }
      if (index > this.currentSlide) {
        slide.classList.remove("before");
      }
    });

    this.indicators.forEach((indicator, index) => {
      if (index === this.currentSlide) {
        indicator.classList.add("active");
      } else {
        indicator.classList.remove("active");
      }
    });

    this.indicatorsAlt.forEach((indicator, index) => {
      if (index === this.currentSlide) {
        indicator.classList.add("active");
      } else {
        indicator.classList.remove("active");
      }
    });

    if (this.currentSlide === 0) {
      this.previousButton.classList.add("disabled");
    } else {
      this.previousButton.classList.remove("disabled");
    }
    if (this.currentSlide === this.textSlides.length - 1) {
      this.nextButton.classList.add("disabled");
    } else {
      this.nextButton.classList.remove("disabled");
    }

    this.checkHeight();
  }
}

customElements.define("text-and-image-carousel", TextAndImageCarousel);
